<div class="container d-flex fd-col jc-center ai-center">
  <h4>
    <mat-icon>{{ icon }}</mat-icon>
  </h4>
  <h4>{{ title }}</h4>
  <p>{{ message }}</p>
</div>